export enum LinkedItemType {
  Goal = 'goal',
  LifeArea = 'lifeArea',
}
